import { render } from "./TheFooter.vue?vue&type=template&id=0b0543b2&scoped=true"
const script = {}

import "./TheFooter.vue?vue&type=style&index=0&id=0b0543b2&lang=scss&scoped=true"

import exportComponent from "c:\\DevOpsProdCore2_02\\_work\\100\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b0543b2"]])

export default __exports__